import { TCurrency } from "@/api/v1_0";
import { Loader } from "@/components";
import { useStore } from "@/store";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement } from "react";
import { Oval } from "react-loader-spinner";
import styles from "./Rates.module.scss";

export const Rates: FunctionComponent = observer((): ReactElement | null => {
  const store = useStore();

  return (
    <span
      className={classNames("currency lightBlockBg", styles.containerDefault)}
      onClick={store.wallet.loadRates}
    >
      {store.wallet.ratesLoading ? (
        <Loader>
          <Oval
            height={15}
            width={15}
            color="#ffffff"
            wrapperStyle={{}}
            wrapperClass=""
            visible
            ariaLabel="oval-loading"
            secondaryColor="#ffffff"
            strokeWidth={1}
            strokeWidthSecondary={1}
          />
        </Loader>
      ) : 0 === store.wallet.rates.size ? null : (
        `1 $ = ${store.wallet.rates.get(TCurrency.USD)} ₽`
      )}
    </span>
  );
});
